import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=86eaadea&scoped=true"
import script from "./TableBody.vue?vue&type=script&lang=ts"
export * from "./TableBody.vue?vue&type=script&lang=ts"
import style0 from "./TableBody.vue?vue&type=style&index=0&id=86eaadea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86eaadea",
  null
  
)

export default component.exports